import Autocomplete, { AutocompleteProps } from '@mui/material/Autocomplete'
import Checkbox from '@mui/material/Checkbox'
import TextField from '@mui/material/TextField'
import { useDashboardFilterOptions } from '../../queries/hooks/useDashboardFilterOptions'

type LocationSelectorProps = {
  value: string[]
  onChange: (value: string[]) => void
} & Omit<
  AutocompleteProps<string, true, false, false>,
  'onChange' | 'value' | 'options' | 'renderInput' | 'multiple'
>

const LocationSelector = ({ value, onChange, ...rest }: LocationSelectorProps) => {
  const { data: allOptions, isLoading: isLoadingOptions } = useDashboardFilterOptions()

  return (
    <Autocomplete
      multiple
      options={allOptions?.locations.map((location) => location ?? '') ?? []}
      value={value}
      onChange={(_, newValue) => onChange(newValue)}
      size="small"
      renderOption={(props, option) => (
        <li {...props} key={option}>
          <Checkbox checked={value.includes(option)} size="small" />
          {option}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={
            value.length > 0
              ? 'Select locations to check compliance for'
              : 'Will apply to all locations'
          }
          inputProps={{ ...params.inputProps, 'data-qa-id': 'config-locations-input' }}
        />
      )}
      loading={isLoadingOptions}
      {...rest}
    />
  )
}

export default LocationSelector
